import { render, staticRenderFns } from "./Bio.vue?vue&type=template&id=3c45eaad&scoped=true&"
import script from "./Bio.vue?vue&type=script&lang=js&"
export * from "./Bio.vue?vue&type=script&lang=js&"
import style0 from "./Bio.vue?vue&type=style&index=0&id=3c45eaad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c45eaad",
  null
  
)

export default component.exports